module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fragment', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.getJCGuidelinesNames(_vm.awardIndex)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getJCGuidelinesInfo(_vm.awardIndex)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.award.generalDamages)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.discount),
      expression: "discount",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number',
        name: 'discount' + _vm.awardIndex,
        min: 0,
        max: 100,
      }),
      expression: "{\n              type: 'number',\n              name: 'discount' + awardIndex,\n              min: 0,\n              max: 100,\n            }",
      modifiers: {
        "required": true
      }
    }],
    staticStyle: {
      "min-width": "5em"
    },
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0",
      "max": "100",
      "required": ""
    },
    domProps: {
      "value": (_vm.discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.award.total)))])]), _vm._v(" "), (!_vm.getDiscountsValid) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('control-error', [_vm._v(" The discount must be between 0 and 100 ")])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ca213fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/awards/AwardValueRow.vue
// module id = 1759
// module chunks = 0